var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EBC354",
    d: "M8 .6l2.5 4.858 5.5.778-4 3.789.9 5.344L8 12.843l-4.9 2.526.9-5.344-4-3.789 5.5-.778z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.f32f8b0c.svg";
export { ForwardRef as ReactComponent };